'use strict';
(function () {

    const self = Fotobook.substrate.custom = {
        /** Пересчет холста c кастомной подложкой */
        recalculate() {
            $(document).triggerHandler(Fotobook.events.RECALC_SUBSTRATE);
        },

        getPageMargins() {
            return {
                height: 0,
                width: 0,
            };
        },

        /** изменить подложку продукта */
        change() {
            self.recalculate();
        },

        /**
         * Пересчитывает размеры подложки с учётом зума.
         * Приходится делать вычисления в данном отдельном методе, т.к. recalculate()
         * вызывается не всегда, а пересчёт нужно делать при любом экшне.
         */
        recalculateWithZoom() {
            // в режиме превью зум не нужен
            if (Fotobook.store.state.OnlineEditor.previewMode) {
                return;
            }

            const $book = $(Fotobook.book.book);

            const $wrapper = $book.closest('.book-wrapper.main-wrapper'); // рабочая область редактора
            const $substrate = $('.substrate-custom');
            const $pageNumber = $('.book-page-num');

            const substrate = {
                height: $substrate.attr('data-height'),
                width: $substrate.attr('data-width'),
                top: $substrate.attr('data-top'),
                left: $substrate.attr('data-left'),
            };

            // без этих данных мы не можем провести калькуляцию
            if (Object.values(substrate).some((val) => !val)) {
                return;
            }

            // вычисляем коеффициент масштабирования
            const initialFontSize = parseFloat($book.attr('data-fontSize'));
            const newFontSize = parseFloat($book.css('font-size')) || initialFontSize;
            const zoomCoefficient = newFontSize / initialFontSize || 1;

            const spaceBetweenControls = 3; // отступ между элементом и кнопками управления, в пикселях
            const $prevButton = $('.book-button-editor.prev');
            const $nextButton = $('.book-button-editor.next');

            // было бы удобнее, если мы были уверены в идентичных размерах кнопок
            const reservedControlsSpace = Math.max($prevButton.width(), $nextButton.width()) + spaceBetweenControls;

            // обновленная ширина/высота после масштабирования
            const newSubstrate = {
                height: substrate.height * zoomCoefficient,
                width: substrate.width * zoomCoefficient,
                top: substrate.top * zoomCoefficient,
                left: substrate.left * zoomCoefficient,
            };

            // при зуме прибиваем блоки влево, насколько это возможно:
            // считаем левый отступ для контента, отталкиваясь от ширины фона
            // учитываем доп. отступ, появившийся от кнопки управления слева
            const wrapperWidth = $wrapper.width() || $wrapper.attr('width');
            let newSubstrateLeft = (wrapperWidth - newSubstrate.width) / 2;
            if (newSubstrateLeft < reservedControlsSpace) {
                newSubstrateLeft = reservedControlsSpace;
            }
            const leftOffset = newSubstrateLeft - newSubstrate.left;

            $book.css({
                top: `${parseFloat($book.attr('data-top')) * zoomCoefficient || 0}px`,
                left: `${parseFloat($book.attr('data-left')) * zoomCoefficient + leftOffset || 0}px`,
            });

            // костыль, однако: т.к. фон выровнен абсолютом, нужно задать высоту jspPane явно
            // добавляем немного пикселей вширь (1 ширину кнопки), чтобы скроллы не перекрывали правую кнопку,
            // т.к. она также выровнена абсолютом и маргин не работает
            const jspPaneWidth = newSubstrateLeft + newSubstrate.width + spaceBetweenControls + reservedControlsSpace + reservedControlsSpace;
            $book.closest('.jspPane').css({
                display: 'flex',
                'align-items': 'center',
                'justify-content': 'center',
                height: `${newSubstrate.height}px`,
                'min-width': `${jspPaneWidth}px`,
            });

            // TODO check commented lines, if something works wrong - try to uncomment
            $substrate.css({
                width: `${newSubstrate.width}px`,
                height: `${newSubstrate.height}px`,
                // top: `${newSubstrate.top}px`,
                // left: `${newSubstrateLeft}px`,
            });

            // элементы навигации
            $prevButton.css({
                left: `${newSubstrateLeft - reservedControlsSpace}px`,
            });
            $nextButton.css({
                // не можем адекватно поставить right, т.к. элемент, по которому ровняем навигацию, выровнен абсолютом
                left: `${newSubstrateLeft + newSubstrate.width + spaceBetweenControls}px`,
            });
            // добавляем немного пикселей, чтобы скроллы не перекрывали название стороны
            $pageNumber.css({
                bottom: `${10 * zoomCoefficient}px`,
            })
        },

        resize() {
            self.recalculate();
            self.recalculateWithZoom();
        },
    };
})();
